import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-variables',
  templateUrl: './variables.component.html',
  styleUrls: ['./variables.component.scss']
})
export class VariablesComponent implements OnInit {

  variables: any[] = [];

  constructor(public rest: RestService) { }

  ngOnInit() {
    this.getVariables();
  }

  getVariables() {
    this.rest.getVariables().subscribe((data) => {
      this.variables = data['data'];
    });
  }

  editVariables(el, $event) {
    this.rest.postVariables(el.id, $event.target.value).subscribe((data) => {
      this.variables = data['data'];
    });
  }

}
